import { Box, Grid, Chip, Typography, Button, Paper } from '@mui/material';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router';
import PropTypes from 'prop-types';
import styles from './CommissionDisplay.module.css';
import { useEffect } from 'react';
import { getPremiumBcChargesNewApi } from 'utils/API/Merchant APIs/MerchantApiCalls';
import { useState } from 'react';
import Spinner from 'views/Components/LoadingSinner';

const MotionPaper = motion(Paper);

const CommissionDisplayComponent = ({ amountResponse }) => {
    const [plansToDisplay, setPlansToDisplay] = useState({ normal: {}, silver: {}, gold: {}, platinum: {} });
    const [loading, setLoading] = useState(false);
    // eslint-disable-next-line
    const matchingPlan = Object.entries(plansToDisplay).find(([_, plan]) => plan.upgradeStatus === 1);
    const currentPlanId = matchingPlan ? matchingPlan[1].id : null;
    const isTopPremium = plansToDisplay.platinum.upgradeStatus === 1;
    const navigate = useNavigate();

    const plans = [
        {
            plan: 'Normal Plan',
            gst: amountResponse?.gst || '',
            totalCommission: amountResponse?.totCommi || '',
            tds: amountResponse?.tds || '',
            totalDebitAmount: amountResponse?.agentDebitAmount || '',
            isCurrent: currentPlanId === 1,
            styleClass: styles.normalPlan,
            id: 1
        },
        {
            plan: 'Silver Plan',
            gst: '₹ 90',
            totalCommission: amountResponse?.silver,
            tds: '₹ 40',
            totalDebitAmount: '₹ 5640',
            isCurrent: currentPlanId === 4,
            styleClass: styles.silverPlan,
            id: 4
        },
        {
            plan: 'Gold Plan',
            gst: '₹ 80',
            totalCommission: amountResponse?.gold,
            tds: '₹ 30',
            totalDebitAmount: '₹ 5630',
            isCurrent: currentPlanId === 3,
            styleClass: styles.goldPlan,
            id: 3
        },
        {
            plan: 'Platinum Plan',
            gst: '₹ 80',
            totalCommission: amountResponse?.platinum,
            tds: '₹ 30',
            totalDebitAmount: '₹ 5630',
            isCurrent: currentPlanId === 2,
            styleClass: styles.platinumPlan,
            id: 2
        }
    ];

    const currentIndex = plans.findIndex((plan) => plan.isCurrent);

    const filteredPlans = currentIndex !== -1 ? plans.slice(currentIndex) : plans;

    // Calculate grid sizes based on number of cards
    const getGridSizes = (cardCount) => {
        switch (cardCount) {
            case 1:
                return { xs: 12, sm: 12, md: 6, lg: 4 }; // Single card - centered
            case 2:
                return { xs: 12, sm: 6, md: 6, lg: 6 }; // Two cards
            case 3:
                return { xs: 12, sm: 6, md: 4, lg: 4 }; // Three cards
            case 4:
                return { xs: 12, sm: 6, md: 3, lg: 3 }; // Four cards in one row
            default:
                return { xs: 12, sm: 6, md: 4, lg: 3 }; // Default fallback
        }
    };

    const gridSizes = getGridSizes(filteredPlans.length);
    //api call to get charges
    const getPremiumPlansAndCharges = async () => {
        setLoading(true);
        const agentid = localStorage.getItem('id');
        const payload = { agentid };
        const response = await getPremiumBcChargesNewApi(payload);
        const data = response?.data?.data;
        const normalPlan = data?.find((item) => item.id === 1);
        const silverPlan = data?.find((item) => item.id === 4);
        const goldPlan = data?.find((item) => item.id === 3);
        const platinumPlan = data?.find((item) => item.id === 2);
        setPlansToDisplay({ normal: normalPlan, silver: silverPlan, gold: goldPlan, platinum: platinumPlan });
        setLoading(false);
    };
    useEffect(() => {
        getPremiumPlansAndCharges();
    }, []);

    return isTopPremium ? null : (
        <Box className={styles.container} onClick={() => navigate('/premium-bc/premium-bc-class-cards')}>
            <Grid container spacing={3} justifyContent="center">
                {filteredPlans?.map((card, index) => (
                    <Grid item {...gridSizes} key={index}>
                        <Box position="relative">
                            <Chip
                                label={card.isCurrent ? 'Current Commission' : 'Higher Commission'}
                                color={card.isCurrent ? 'primary' : 'success'}
                                className={styles.ribbon}
                            />
                            <MotionPaper
                                elevation={4}
                                whileHover={{ scale: 1.05 }}
                                whileTap={{ scale: 0.98 }}
                                className={`${styles.card} ${card.styleClass}`}
                            >
                                <Typography variant="h6" className={styles.planTitle}>
                                    {card.plan}
                                </Typography>
                                <Typography className={styles.commissionData}>
                                    Total Commission:
                                    <span className={styles.commissionAmount}> {card.totalCommission}</span>
                                    <span className={styles.additionalInfo}> (*including GST)</span>
                                </Typography>
                                {card.isCurrent ? (
                                    <Button variant="contained" className={styles.buttonCurrent} disabled>
                                        Current Plan
                                    </Button>
                                ) : (
                                    <motion.div
                                        animate={{ scale: [1, 1.1, 1] }}
                                        transition={{ duration: 1, repeat: Infinity, repeatType: 'reverse' }}
                                    >
                                        <Button
                                            variant="contained"
                                            className={styles.button}
                                            onClick={() => navigate('/premium-bc/premium-bc-class-cards')}
                                        >
                                            Unlock now
                                        </Button>
                                    </motion.div>
                                )}
                            </MotionPaper>
                        </Box>
                    </Grid>
                ))}
            </Grid>
            <Spinner loading={loading} />
        </Box>
    );
};

CommissionDisplayComponent.propTypes = {
    amountResponse: PropTypes.object
};

export default CommissionDisplayComponent;
